export const DATE_PICKER_INPUT_DEFAULT_VALUE = '__/____';
